<template>
  <el-col :span="24" class="header-box">
    <el-col :span="specialChannel?4:16" class="logo" :class="{'logo__special':specialChannel}">
      <span class="header-box__title">
        <img :src="(customInfo && (customInfo.logo || `/static/${customInfo.subdomain}/logo.png`)) " alt=""
          class="cloud__image" v-if="customInfo">
        <img src="@/assets/images/feiche@2x.png" alt="" class="cloud__image default__image" v-else>
        {{collapsed?'':sysName}}
      </span>
      <template v-if="showMenus">
        <div class="header-box__menu">
          <template v-for="(item,index) in headerMenus">
            <div class="header__item" @click="handleSelect(item)" :key="index" :id="`item_${index}`"
              :class="{'active':activeTab===item.url || +activeTab === +item.permissionCode}">{{item.menuName}}</div>
            <!-- <span v-if="+item.menuId===251" :id="index" @dblclick.stop="openBrowser" :key="`span_${index}`"
              class="hidden_pointer"></span> -->
          </template>
        </div>
        <div class="header-box__v2" @click="goToV2Version()" v-if="!disabedV2Site" v-isdataauthority>
          返回V2
        </div>
      </template>
    </el-col>
    <el-col :span="specialChannel?16:8" class="userinfo" v-if="showMenus">
      <span v-if="hongbaoShow" class="hongbao" @click="activitiesVisible = true">
        <el-badge :hidden="drawsNum?false:true" :value="drawsNum" class="badge">
          <img src="@/assets/images/hongbao.png" alt="" icon="el-icon-share" class="cloud__image default__image">
        </el-badge>
      </span>
      <i class="iconfont icon-shezhi1" v-show="hasSetting" @click="openSetting"></i>
      <el-dropdown trigger="hover" placement="bottom" v-if="!customInfo">
        <el-badge :value="newCount" :max="99" :hidden="!newCount" class="item">
          <i class="iconfont icon-kefu6"></i>
        </el-badge>
        <el-dropdown-menu slot="dropdown" class="el-dropdown-menu__header">
          <div class="message-box">
            <div class="message-box__item flex flex-b">
              <div class="online-KF">
                <i class="el-icon-headset"></i>
                <span class="message-box__item__text icon-kf__text" @click="openKF">
                  <el-badge :value="newCount" :max="99" :hidden="!newCount" class="item badge__kf">
                    <div class="item_txt">在线客服</div>
                  </el-badge>
                </span>
              </div>
              <div class="online-complaint">
                <i class="iconfont icon-tousujianyi"></i>
                <span class="message-box__item__text icon-kf__text" @click="openComplaint">
                  <span class="item_txt">投诉建议</span>
                </span>
              </div>
            </div>
            <div class="message-box__item flex">
              <i class="iconfont icon-dianhua"></i>
              <span class="message-box__item__text flex flex-d">
                <span>010-86461128（8:30-21:00）</span>
              </span>
            </div>
            <div class="message-box__item flex">
              <div class="box__item">
                <i class="iconfont icon-erweima"></i><span class="message-box__item__text">微信公众号</span>
                <div class="qrcode-box">
                  <img src="@/assets/qrcode.jpg" alt="">
                </div>
              </div>
              <!-- <div class="box__item">
                <i class="iconfont icon-erweima"></i><span class="message-box__item__text">微信客服1</span>
                <div class="qrcode-box">
                  <img src="@/assets/weixin.png" alt="" class="qrcode-box__img">
                </div>
              </div> -->
              <div class="box__item">
                <i class="iconfont icon-erweima"></i><span class="message-box__item__text">微信客服</span>
                <div class="qrcode-box">
                  <img src="//f2.youbaolian.top/baksite/resources/img/weixin2.png" alt="" class="qrcode-box__img">
                </div>
              </div>
            </div>
            <div class="message-box__item flex">
              <div class="box__item">
                <img src="//f2.youbaolian.top/baksite/resources/img/ashun-small.png" class="img-small" alt=""><span class="message-box__item__text">优保联创始人阿瞬</span>
                <div class="qrcode-box">
                  <img src="//f2.youbaolian.top/baksite/resources/img/ashun.jpg" alt="">
                </div>
              </div>
              <div class="box__item">
                <div class="qrcode-box video-box">
                  <div>如果您在使用我们产品或服务时：</div>
                  <ul>
                    <li>❌ 遇到任何迟迟未解决的问题</li>
                    <li>❌ 心中有任何不吐不快的吐槽</li>
                    <li>❌ 有能让产品变得更好的金点子</li>
                  </ul>
                  <div>现在，您有了一个直达创始人的<span>“特权窗口”</span></div>
                </div>
              </div>
            </div>
          </div>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown trigger="hover" placement="bottom" v-if="!customInfo">
        <el-badge :value="unReadCount" class="el-badge__item" :hidden="+unReadCount===0">
          <i class="iconfont icon-gonggao"></i>
        </el-badge>
        <el-dropdown-menu slot="dropdown" class="el-dropdown-menu__header">
          <div class="tab-box">
            <header-notice @open="openNotice" @gzh="openGZH" :ejectGZH="ejectNotice"></header-notice>
          </div>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown trigger="hover" placement="bottom">
        <span class="el-dropdown-link userinfo-inner">
          <i class="iconfont icon-wode1"></i>
          <span>{{userInfo && `${loginName}-${userInfo.RealName}`}}</span><i
            class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown" class="el-dropdown-menu__header" :style="getVersionBackground">
          <div class="header-box__user">
            <div class="header-box__user__box">
              <!-- 组织切换 -->
              <div class="header-box__user__name">{{loginName}}</div>
              <!-- <el-dropdown @command="changeRoles" v-else>
                <span class="el-dropdown-link">
                  {{ organizationName }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="item in additionRoles" :key="item.organizationId" :command="item.id"
                    :disabled="userInfo && (+item.organizationId === +userInfo.OrganizationId)">{{ item.organizationName }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown> -->
              <div class="header-box__user__subdomain">{{userInfo && `${userInfo.Pratner.subdomain}`}}</div>
              <div class="header-box__user__role"
                v-for="item in (userInfo && userInfo.CustomerAdditionalRoleVoList) || []" :key="item.roles">
                <small>{{ item.rolesName }}</small>
              </div>
              <div class="header-box__user__version">
                <img v-if="versionBadgeSrc" :src="versionBadgeSrc" @error="onVersionBadgeError" alt="">
              </div>
            </div>
            <!-- <el-divider></el-divider> -->
            <div class="header-box__user__action">
              <el-col :span="6">
                <el-tooltip effect="dark" content="修改资料" placement="top">
                  <i class="iconfont icon-renyuan1" @click="changeInfo"></i>
                </el-tooltip>
              </el-col>
              <el-col :span="6">
                <el-tooltip effect="dark" content="修改密码" placement="top">
                  <i class="icon-bianji iconfont" @click="changePwd"></i>
                </el-tooltip>
              </el-col>
              <el-col :span="6">
                <el-tooltip effect="dark" content="锁屏" placement="top">
                  <i class="icon-suoding iconfont" @click="lockScreen"></i>
                </el-tooltip>
              </el-col>
              <el-col :span="6">
                <el-tooltip effect="dark" content="退出" placement="top">
                  <i class="icon-tuichu iconfont" @click="logout"></i>
                </el-tooltip>
              </el-col>
            </div>
          </div>
        </el-dropdown-menu>
      </el-dropdown>
    </el-col>
    <ybl-dialog :visible="dialog.visible" :title="dialog.title" @close="close" :showFooter="dialog.step===2"
      :showHeader="dialog.step!==2" @confirm="submit">
      <template v-if="dialog.step===0">
        <div class="dialog-box__title center">{{currentItem.Title}}</div>
        <div class="dialog-box__time center">{{currentItem.UpdateTime | dayFormat('YYYY-MM-DD HH:mm:ss')}}</div>
        <div class="dialog-box__content" v-html="currentItem.Content"></div>
      </template>
      <div v-else-if="dialog.step===1" v-html="noticeInfo.Content"></div>
      <ybl-browser ref="dialog" v-else-if="dialog.step===2"></ybl-browser>
    </ybl-dialog>
    <ybl-dialog :visible="dynamic.visible" :title="dynamic.title" @close="close" :showFooter="false">
      <el-carousel :interval="4000" height="400px">
        <el-carousel-item v-for="(item,index) in dynamic.items" :key="index">
          <div class="carouse-item__content" v-html="item.Content"></div>
        </el-carousel-item>
      </el-carousel>
    </ybl-dialog>
    <ybl-dialog :visible="remindNotice.visible" :title="remindNotice.title" @close="close" :showFooter="false">
      <ybl-notice-remind :dataList="remindNotice.list"></ybl-notice-remind>
    </ybl-dialog>
    <!-- 抽奖业务 -->
    <activities v-if="activitiesVisible" @actEvent="queryNumberOfLuckyDraw" @close="onHbClose">
    </activities>
  </el-col>
</template>
<script>
import { openNavUrl, openQmm, storage, day, getMac, getVersion, isSpecialChannel, getConfigInfo } from '@/utils'
import crypto from '@/utils/crypto'
import cookie from '@/utils/cookie'
import human from '@/utils/human'
import feiche from '@/router/feiche'
import product from '@/router/product'
import ultimate from '@/router/ultimate'
import finance from '@/router/finance'
import dataManage from '@/router/dataManage'
import settingRouters from '@/router/setting'
import activities from '@/views/activities/HongBao'
import { mapGetters } from 'vuex'
import { customDomainAndLogo } from '@/config/automatic'
import { getVersionBadgeUrl, getVersionFlag } from '@/utils/version'
import axios from 'axios'
export default {
  name: 'yblHeader',
  props: {
    ejectNotice: { //  是否自动弹出公告信息
      type: Boolean,
      default: () => true
    },
    showMenus: { // 是否显示顶部菜单项
      type: Boolean,
      default: () => true
    }
  },
  data () {
    return {
      collapsed: false,
      versionBadgeFailed: false, // 创收版版本角标图加载失败（如新版本图未上传）时不展示
      dialog: {
        visible: false,
        title: '公告',
        step: 0 // 0:默认公告提示信息    1:关注公众号提示操作
      },
      newCount: 0,
      constTitle: ['公告信息', '更新日志', '重要通知'],
      currentItem: {},
      unReadCount: '',
      noticeInfo: {},
      remindNotice: {
        title: '查看公告',
        visible: false,
        list: [1]
      },
      dynamic: {
        // 动态弹窗属性值
        title: '温馨提示',
        visible: false,
        items: []
      },
      hasSetting: false,
      headerMenus: [],
      originMenus: [],
      activeTab: '',
      guideVisible: false,
      activitiesVisible: false,
      help: {
        menuName: '',
        permissionId: 400
      },
      trainDomain: '/train', // 'xiaoeknow.com',
      gzhItem: null, // 定义一个对象存储公众号公告信息
      hongbaoShow: false, // 是否显示红包入口
      drawsNum: 0// 抽奖次数
    }
  },
  created () {
    this.activeTab = location.pathname // this.$route.path
    let host = location.host
    const href = location.href
    const isDev = process.env.NODE_ENV === 'development'
    const isWebV3 = isDev || host.includes('cxv3-new.youbaolian')
    const isQuote = isDev || host.includes('quote-new.youbaolian') || href.includes('/q/') || href.includes('LitePaperOffer/newindex')
    const isJavaV3 = isDev || host.includes('cxv3.youbaolian') || href.includes('/j/')
    const isFeiChe = isDev || this.activeTab.includes('/FeiCheJava/') || this.activeTab.includes('/home/feicheindex')
    const isSXCore = isDev || host.includes('sxcore-test.youbaolian') || host.includes('sxcore.youbaolian') || href.includes('/sho/#')
    const isStudy = isDev || host.includes('study.youbaolian')

    if (isWebV3) { // && !isQuote && !isJavaV3 && !isSXCore
      this.activeTab = (!['/home', '/human', '/setting', '/product', '/dataManage'].includes(this.activeTab) && '/home') || location.pathname
      let data = human.map(item => item.path)
      data.push('/organization/home')
      if (location.pathname === '/myhome') {
        this.activeTab = '99' // '1341'
      } else if (location.pathname.includes('/client')) {
        this.activeTab = '40'
      } else if (data.includes(location.pathname)) {
        this.activeTab = '8801' // '262'
      } else if (product.map(item => item.path).includes(location.pathname)) { // 产品
        this.activeTab = '60' // '1176'
      } else if (feiche.map(item => item.path.replace(/\/:id/, '')).includes(location.pathname.replace(/\/\d+/, ''))) { // 非车
        this.activeTab = '14' // '224'
      } else if (ultimate.map(item => item.path).includes(location.pathname)) { // 旗舰版
        this.activeTab = '56' // '674'
      } else if (finance.map(item => item.path).includes(location.pathname)) { // 财务
        this.activeTab = '26' // '677'
      } else if (settingRouters.map(item => item.path).includes(location.pathname)) {
        this.activeTab = '31' // '348'
      } else if (dataManage.map(item => item.path).includes(location.pathname)) {
        this.activeTab = '70' // '1215'
      } else if (isQuote && !isDev) {
        this.activeTab = '2' // 7
      } else if (isSXCore && !isDev) {
        this.activeTab = '20' // '290' // 寿险的permissionId
      } else if (isJavaV3 && !isDev) {
        this.activeTab = '17' // '251'
        if (isFeiChe) {
          this.activeTab = '14' // '224'
        }
        /* const url = location.pathname.replace(/^\/j\//, '')
        const isFinance = ['Report/Finance', 'finance/salesmanCheckApply', 'finance/RewardsRecord/1', 'FeiCheJava/supplierSettleRate'].includes(url)
        if (isFinance) {
          this.activeTab = '677'
        } */
      }
    } else if (isFeiChe) {
      this.activeTab = '14' // '224'
    } else if (isJavaV3) {
      this.activeTab = '17' // '251'
    } else if (isSXCore) {
      this.activeTab = '20' // '290' // 寿险的permissionId
    } else if (isStudy) {
      this.activeTab = '45' // '353'
    } else if (isQuote) {
      this.activeTab = '2' // '7'
    }
    if (!this.userInfo) {
      this.loginCustomer().then(() => {
        this.initData()
      })
    } else {
      this.initData()
    }
  },
  mounted () {
    let _this = this
    let query = this.$route.query
    if (window.performance.navigation.type === 1) {
      console.log('页面被刷新！')
      // this.checkCurrentUser()
    } else {
      console.log('首次被加载！')
      this.$nextTick(() => {
        const { id, _xid, ...rest } = query
        if (this.ejectNotice && !_this.dynamic.visible && _xid && Object.keys(rest).length === 0) { // 公众号弹窗，不存在（处理同时弹窗问题）
          _this.getNoticeQuerySystemNoticesForReleased()
        }
      })
    }
    // this.monitorTabChange()
    window.addEventListener('visibilitychange', _this.monitorTabChange, false)
    _this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('visibilitychange', _this.monitorTabChange, false)
      window.removeEventListener('resize', _this.setHiddenPointer, false)
    })
    // 网易客服监听
    window.ysf && window.ysf('onunread', function (result) {
      _this.newCount = result.total
    })
    // 根据customerId获取组织角色列表
    // this.getCustomerQueryAdditionRole(this.userInfo.CustomerId)
  },
  computed: {
    ...mapGetters([
      'CUSTOMER_LOGINCUSTOMER',
      'commonData'
    ]),
    userInfo () {
      return this.CUSTOMER_LOGINCUSTOMER.data
    },
    sysName () {
      return (this.customInfo && this.customInfo.name) || cookie.getCookie('__system__') || '保险智能云平台'
    },
    loginName () {
      return this.userInfo && (this.userInfo.LicensePlateLabelName || this.userInfo.Pratner.partnername)
    },
    token () {
      return this.commonData.token || cookie.getCookie('InsBackUserToken_V3') || ''
    },
    // additionRoles () {
    //   return this.commonData.additionRole || []
    // },
    // organizationName () {
    //   let item = {}
    //   if ((this.userInfo && this.userInfo.OrganizationId) && this.additionRoles.length > 0) {
    //     item = this.additionRoles.filter(c => { return +c.organizationId === +this.userInfo.OrganizationId })[0] || {}
    //   }
    //   return item.organizationName
    // },
    setting () {
      let menu = this.originMenus.filter(item => +item.permissionId === 348)
      return menu && menu.length && menu[0]
    },
    menuPaths () {
      return this.originMenus.map(item => item.url)
    },
    disabedV2Site () {
      return (this.userInfo && this.userInfo.Pratner && this.userInfo.Pratner.partnerEx && this.userInfo.Pratner.partnerEx.disabedV2Site)
    },
    parergonMgr () {
      return this.userInfo && this.userInfo.Pratner && (+this.userInfo.Pratner.systemVersion === 21 && this.userInfo.Mgr)
    },
    partner () {
      return this.userInfo && this.userInfo.Pratner
    },
    customInfo () {
      const subdomain = (this.partner && this.partner.subdomain) || ''
      const item = customDomainAndLogo.find(item => item.subdomain === subdomain)
      return item
    },
    isMicroApp () {
      /* const path = this.$route.path
      return path.includes('/j/') || path.includes('/q/') || path.includes('/sho/') */
      // return true
      return process.env.IS_MICRO_APP
    },
    specialChannel () {
      const { IsChannelCustomer } = this.userInfo
      const isSpecial = IsChannelCustomer // [3, 4, 22].includes(+Pratner.systemVersion) && [12, 13, 14].includes(+RoleGroupIds)
      return isSpecialChannel() || isSpecial
    },
    v5Flag () {
      return getVersionFlag(this.partner)
    },
    // 创收版版本角标：version/{档位}_{版本}.png（如 5_V6.png）
    //   档位取 v5Flag（1试用/3入门/4标准/5专业/6旗舰），版本取 revenueVersion（V5/V6/V7…，空按V5）
    //   图片加载失败（如新版本图未上传）时不展示；地址与规则统一维护在 @/utils/version
    versionBadgeSrc () {
      return this.versionBadgeFailed ? '' : getVersionBadgeUrl(this.partner)
    },
    getVersionBackground () {
      const v5Flag = this.v5Flag
      switch (v5Flag) {
        case '6': // 旗舰版
          return { background: 'linear-gradient(145deg, #f5f7fa 10%, #f5f7fa 40%, #01015d 100%)' }
        case '5': // 专业版
          return { background: 'linear-gradient(145deg, #f5f7fa 10%, #f5f7fa 40%, #603001 100%)' }
        case '4': // 标准版
          return { background: 'linear-gradient(145deg, #f5f7fa 10%, #f5f7fa 40%, #70acd7 100%)' }
        case '3': // 入门版
          return { background: 'linear-gradient(145deg, #f5f7fa 10%, #f5f7fa 40%, #FADDA3 100%)' }
        case '1': // 试用
          return { background: 'linear-gradient(145deg, #f5f7fa 10%, #f5f7fa 40%, #CEE7F9 100%)' }
        default: // 禁用或其他
          return { background: 'linear-gradient(145deg, #f5f7fa 10%, #f5f7fa 40%, #e4e8f0 100%)' }
      }
    }
  },
  components: {
    activities
  },
  methods: {
    onVersionBadgeError () {
      this.versionBadgeFailed = true
    },
    initData () {
      this.initHeaderMenu()
      this.queryNumberOfLuckyDraw()
    },
    onHbClose () {
      this.activitiesVisible = false
      this.queryNumberOfLuckyDraw()
    },
    monitorTabChange () {
      if (document.hidden !== undefined) {
        // document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          this.checkCurrentUser()
        }
        // })
      }
    },
    checkCurrentUser () {
      const unionId = cookie.getCookie('unionIdCRM') || cookie.getCookie('unionId')// localStorage.getItem('unionId')
      const loginName = this.userInfo && this.userInfo.CustomerId// LoginName
      const partnerId = this.userInfo && this.userInfo.PartnerId// Pratner && this.userInfo.Pratner.subdomain
      const subdomain = (this.partner && this.partner.subdomain) || ''
      console.log('unionId = ', unionId, loginName)
      const item = customDomainAndLogo.find(item => item.subdomain === subdomain)
      const path = item ? item.path : '/login'
      if (unionId.toLowerCase() !== `${partnerId}${loginName}`.toLowerCase() && this.$route.path !== path) {
        if (item) {
          window.location.href = `${location.protocol}//${subdomain}.${item.domain}${path}`
        } else {
          this.$router.replace({ path: '/login' })
        }
      }
    },
    open (item) {
      console.log(item)
      this.currentItem = item
      let index = (item && +item.noticeType) || 2
      this.dialog.title = this.constTitle[+index]
      this.dialog.visible = true
    },
    close () {
      this.dialog.visible = false
      this.remindNotice.visible = false
      if (this.dynamic.visible) {
        this.dynamic.visible = false
        this.getNoticeQuerySystemNoticesForReleased()
      }
    },
    openNotice (item) {
      this.dialog.step = 0
      this.open(item)
    },
    openGZH (item) {
      let gzh = storage.getItem('gzh')
      if (!gzh && item && item.Notices.length) {
        this.dynamic.items = item.Notices || []
        this.gzhItem = item.Notices[0]
        storage.setItem('gzh', 'gzh')
        this.dynamic.visible = true
      }
    },
    // 退出登录
    logout: function () {
      let _this = this
      this.$confirm('确认退出吗?', '提示', {
        // type: 'warning'
      }).then(() => {
        _this.$store.dispatch('resetCommon').then(() => {
          const info = getConfigInfo()
          const subdomain = (this.partner && this.partner.subdomain) || (info && info.subdomain) || ''
          const item = customDomainAndLogo.find(item => item.subdomain === subdomain)
          const path = item ? item.path : '/login'
          let isDev = process.env.NODE_ENV === 'development'
          if (isDev) {
            this.$router.push({ path: path })
          } else {
            /* if (item) {
              openNavUrl('/Home/LoginOut', '', 'cxv3.youbaolian.top', 'self')
            } else { */
            const prefix = process.env.NODE_ENV === 'production' ? '' : 'test-'
            const url = `//${prefix}bi.youbaolian.top/eacl/js/login.do?action=logout&__t__= ${(new Date()).getTime()}`
            axios({
              method: 'get',
              url: url,
              withCredentials: true
            }).then((data) => {
              _this.goToOuter('/Home/LoginOut')
            }).catch(() => {
              _this.goToOuter('/Home/LoginOut')
            })

            /* } */
          }
        })
      }).catch(() => {
      })
    },
    handleSelect (item) {
      // 【临时兜底】AI合伙人 入口不能直跳 /dsh/（DSH 需要免登握手，直跳会落空白页），
      // 与 /myhome 首页 banner 保持一致：先顶层跳 pre0 免登中转页，
      // 由该页在 pre0 域内「建单 → 取新链接 → 换 token → 写 cookie → 跳 DSH」。
      // ⚠️ 下面原有的 case 10008 保持原样未改动；后端正式方案启用后一并按需调整。
      // if (isAiPartnerMenuPermission(item)) {
      //   window.location.href = aiPartnerConfig.loginPageUrl
      //   return
      // }
      let url = ''
      let v3pathname = ''
      let title = item.menuName
      let { host, protocol, origin } = location // location.host.replace('cxv3', 'insbak')
      console.log('🚀 ~ file: Header.vue:418 ~ handleSelect ~ host:', host)
      let isCross = true
      let id = ''
      let isProduction = process.env.NODE_ENV === 'production'
      const isDev = process.env.NODE_ENV === 'development'
      const prefix = host.split('.')[0]
      switch (+item.permissionCode) {
        case 2: //  '出单中心'7
          url = item.url // 'LitePaperOffer/newindex#A'
          /* if (this.isMicroApp) {
            host = `${host}/j`
            isCross = false
          } */
          id = 'n10001'
          break
        case 14: //  '非车平台' 224
          // url = item.url // 'home/feicheindex'
          v3pathname = item.url
          id = 'n10006'
          isCross = false
          break
        case 99: // 首页 1325
          v3pathname = item.url
          id = 'n1325'
          isCross = false
          break
        case 17: //  '车险平台V3'251
          v3pathname = item.url // '/home'
          break
        case 20: //  '寿险平台' 290
          url = '/myhome'
          if (this.isMicroApp) {
            host = `${host}/sho/#`
            isCross = false
          } else {
            host = `http://${isProduction ? '' : `${prefix}.`}sxcore.youbaolian.top/#`
          }
          id = 'n10005'
          break
        case 40: //  '客户'
          v3pathname = item.url.replace(origin.replace(/pre[1|2]\./, ''), '')
          if (isDev) {
            const [, path] = item.url.split('//')
            const [, ...reset] = (path || item.url).split('/')
            v3pathname = `/${reset.join('/')}`
          }
          id = 'clientele'
          isCross = false
          break
        case 41: //  '电销'
          url = `/complete?saastoken=${this.token}&code=${+item.permissionCode}`
          host = `${protocol}//${isProduction ? '' : `${prefix}.`}${process.env.ROBOT_PATH.replace('//', '')}`
          id = 'n30002'
          isCross = false
          break
        case 8801: //  '人管'262
        case 56: // '分支'674
        case 26: // 财务677
          // case 22: // 非车 新版本676
          v3pathname = item.url // '/hegui'
          id = 'hegui'
          isCross = false
          break
        case 45: //  '培训平台'353
          url = '/train'
          // host = '//appwkcva14z4502.h5.xiaoeknow.com'
          id = 'n100035'
          isCross = false
          break
        case 60: //  '产品'1176
          v3pathname = item.url // '/product'
          id = 'product'
          isCross = false
          break
        case 31: //  '设置'348
          v3pathname = item.url // '/setting'
          id = 'setting'
          isCross = false
          break
        case 70: //  '数据'1215
          v3pathname = item.url || '/dataManage' // '/'
          id = 'dataManage'
          isCross = false
          break
        case 10008: //  'AI合伙人'(优保联 DSH，同域 /dsh 路径，由平台网关转发)
          url = '/dsh/'
          isCross = false
          id = 'dsh'
          break
        // case 400: // 帮助400
        //   url = '/'
        //   host = '//docs.youbaolian.top/'
        //   id = 'help'
        //   break
      }
      console.log('🚀 ~ file: Header.vue:491 ~ handleSelect ~ v3pathname:', v3pathname, url)
      // this.activeTab = id
      if (url) {
        openNavUrl(url, title, host, 'blank', isCross, 0, id)
      } else if (location.pathname !== v3pathname) {
        /* if (this.isMicroApp && window.IAgencyWebCall && host.includes('cxv3.')) {
          host = host.replace('cxv3.', 'cxv3-new.')
          openNavUrl(v3pathname, title, host, 'self', false)
          return
        } */
        this.$router.push({ path: v3pathname })
      }
    },
    // 打开设置页面
    openSetting () {
      let settingItem = this.originMenus.filter(item => +item.permissionId === 348)[0]
      if (location.pathname !== settingItem.url) {
        /* if (this.isMicroApp && window.IAgencyWebCall && location.host.includes('cxv3.')) {
          let host = location.host.replace('cxv3.', 'cxv3-new.')
          openNavUrl(settingItem.url, settingItem.menuName, host, 'self', false)
          return
        } */
        this.$router.push({ path: settingItem.url })
      }
    },
    goToV2Version () {
      let isCross = true
      let id = ''
      let title = '车险平台'
      let host = location.host.replace('cxv3', 'insbak')
      let url = 'home/index'

      if (url) {
        openNavUrl(url, title, host, 'blank', isCross, 0, id)
      }
    },
    changeInfo () {
      this.goToOuter('/Home/Base')
    },
    changePwd () {
      this.$router.push({ path: '/change/password' })
    },
    lockScreen () {
      this.goToOuter(`/Home/Lockscreen?l=${this.userInfo.LoginName}&r=${this.userInfo.RealName}`)
    },
    goToOuter (url) {
      openNavUrl(url, '', location.host, 'self')
    },
    openQmm () {
      openQmm(this.userInfo.PartnerId, this.userInfo.CustomerId)
    },
    getUnreadNoticeForIndexCount () {
      this.$store.dispatch('noticeGetUnreadNoticeForIndexCount').then(({ data }) => {
        console.log(data)
        this.unReadCount = data
      })
    },
    getMenu () {
      return this.$store.dispatch('customerGetMenu', { id: '0' }).then(data => {
        return data
      })
    },
    initHeaderMenu () {
      if (this.specialChannel) {
        return
      }
      this.getMenu().then(data => {
        this.originMenus = data.datas || []
        this.headerMenus = this.originMenus.filter(item => +item.permissionId !== 348)
        this.hasSetting = this.originMenus.filter(item => +item.permissionId === 348).length > 0
      })
    },
    getNoticeQuerySystemNoticesForReleased () {
      if (this.customInfo && this.customInfo.subdomain.includes('zsl')) { //  针对【臻顺溜】特殊处理
        return
      }
      this.$store.dispatch('noticeQuerySystemNoticesForReleased').then(data => {
        let items = data.DtoList || []
        if (this.gzhItem) { // 添加判断过滤掉公众号的公告信息（公众号的信息单独弹出）
          items = items.filter(item => item.noticeId !== this.gzhItem.NoticeId)
        }
        if (items && items.length) {
          this.remindNotice.list = items // data.DtoList
          this.remindNotice.data = data
          this.remindNotice.visible = true
          this.noticeBatchUpdateSystemNotice().then(() => {
            this.gzhItem = null
          })
        }
      })
    },
    noticeBatchUpdateSystemNotice () {
      let params = {}
      params.dtoList = this.remindNotice.list.map(c => ({
        noticeId: c.noticeId,
        type: c.type,
        views: c.views,
        detailCount: c.detailCount
      }))
      return this.$store.dispatch('noticeBatchUpdateSystemNotice', params).then(data => {
      })
    },
    goJobNoPage () {
      this.guideVisible = false
      this.$router.push({ path: '/jobnum/home' })
    },
    kfConfig () {
      let self = this
      try {
        let userInfo = this.userInfo
        let _uid = userInfo.CustomerId + getMac()
        let _regDate = (userInfo.AddTime && `${userInfo.AddTime}`.includes('/Date(') && day.dayFormat(userInfo.AddTime, 'YYYY-MM-DD HH:mm:ss')) || userInfo.AddTime
        let _subdomain = this.partner.subdomain ? '（' + this.partner.subdomain + '）' : ''

        window.ysf('config', {
          uid: _uid,
          name: this.partner.subdomain + userInfo.RealName,
          email: userInfo.Email,
          mobile: userInfo.Mobile,
          data: JSON.stringify([
            { 'key': 'real_name', 'value': this.partner.subdomain + userInfo.RealName },
            { 'key': 'mobile_phone', 'value': userInfo.Mobile },
            { 'key': 'email', 'value': userInfo.Email },
            { 'key': 'avatar', 'label': '头像', 'value': '' },
            { 'index': 1, 'key': 'partner_name', 'label': '商户', 'value': this.partner.partnername + _subdomain },
            { 'index': 2, 'key': 'account', 'label': '账号', 'value': userInfo.LoginName, 'href': '' },
            { 'index': 3, 'key': 'sex', 'label': '性别', 'value': userInfo.Sex === 1 ? '男' : userInfo.Sex === 2 ? '女' : '未知' },
            { 'index': 4, 'key': 'reg_date', 'label': '创建日期', 'value': _regDate }
          ]),
          // staffid: '', // 指定客服id
          // groupid: '', // 指定客服组id
          // shuntId: '', // 访客选择多入口分流模版id
          // level: 1, // 企业当前登录用户vip等级
          // qtype: 1056, // 企业常见问题模板id
          // welcomeTemplateId: 1024, // 企业欢迎语模板id
          success: function () {
            window.ysf('open')
          }, // 配置成功回调
          error: function () { }// 配置失败回调
        })

        // 监听
        window.ysf('onunread', function (result) {
          self.newCount = result.total
        })
      } catch (e) { }
    },
    openKF () {
      this.newCount = 0
      this.kfConfig()
    },
    openComplaint () {
      openNavUrl('http://youbaolian.mikecrm.com/bP8xZOU', '', location.host, 'blank')
    },
    setHiddenPointer () {
      const hiddenItem = document.querySelector('.hidden_pointer')
      if (!hiddenItem) {
        return
      }
      const id = hiddenItem.id
      const leftItem = document.querySelector(`#item_${id}`)
      const rightItem = document.querySelector(`#item_${+id + 1}`)
      const leftDom = leftItem.getBoundingClientRect()
      const rightDom = rightItem.getBoundingClientRect()
      hiddenItem.style.width = `${rightDom.left - (leftDom.left + leftDom.width - 40)}px`
      hiddenItem.style.left = `${leftDom.left + leftDom.width - 20}px`
    },
    submit () {
      this.$refs['dialog'].submit()
    },
    // 获取组织
    // getCustomerQueryAdditionRole (customerId) {
    //   this.$store.dispatch('customerQueryAdditionalRole', { customerId: customerId }).then(res => {
    //     console.log('customerQueryAdditionalRole', res.dtoList)
    //     this.$store.dispatch('setCommon', { key: 'additionRole', value: res.dtoList })
    //   })
    // },
    // 切换组织
    changeRoles (id) {
      console.log('changeRoles: ', id)
      let params = {
        partnerId: this.partner.partnerid,
        customerAdditionalRoleModel: [
          {
            id: id
          }
        ]
      }
      this.$store.dispatch('customerSwitchAdditionalRole', params).then((res) => {
        console.log('customerSwitchAdditionalRole', res)
        let userSub = this.userInfo.Pratner.subdomain
        // res.Customer.Pwd  res.Customer.LoginName  res.Customer.PartnerId
        this.$store.dispatch('resetCommon').then(() => {
          storage.removeItem('gzh')
          // const subdomain = (this.partner && this.partner.subdomain) || ''
          // const item = customDomainAndLogo.find(item => item.subdomain === subdomain)
          // // const path = item ? '/page/login' : '/login'
          // // let isDev = process.env.NODE_ENV === 'development'
          // // if (isDev) {
          // //   this.$router.push({ path: path })
          // // } else {
          // if (item) {
          //   openNavUrl('/Home/LoginOut', '', 'cxv3.youbaolian.top', 'self')
          // } else {
          //   this.goToOuter('/Home/LoginOut')
          // }
          // }
          this.dealReLogin(res.Customer, userSub)
        })
      })
    },
    loginCustomer () {
      return this.$store.dispatch('customerLoginCustomer').then(({ data }) => {
        return data
      })
    },
    dealReLogin (customer, subdomain) {
      let params = {
        appVersion: getVersion(),
        businessNo: subdomain,
        clientIp: getMac(),
        clientType: 2,
        loginName: customer.LoginName,
        loginPwd: customer.Pwd,
        loginType: 1
      }
      console.log(params)
      this.$store.dispatch('unionUnionLoginEncryptionPortal', { encryption: crypto.Encrypt(JSON.stringify(params)) }).then(response => {
        let { data } = response
        console.log(data, cookie, response)
        let isDev = process.env.NODE_ENV === 'development'
        let domain = isDev ? '' : '.youbaolian.top'
        cookie.setCookie('InsBackUserToken_V3', data.token, domain)
        this.loginCustomer().then((res) => {
          const unionId = `${res.PartnerId}${res.CustomerId}`
          cookie.setCookie('unionId', unionId, domain)
          location.reload()
        })
      })
    },
    queryNumberOfLuckyDraw () {
      let params = {
        partnerId: this.userInfo.PartnerId,
        customerId: this.userInfo.CustomerId
      }
      return this.$store.dispatch('matchPlatformQueryNumberOfLuckyDraw', params).then(data => {
        this.hongbaoShow = !!((data && data.dto && data.dto.isShow))
        this.drawsNum = (data && data.dto && data.dto && data.dto.notUsedLuckDraw) || 0
        let carProgramList = (data && data.dto && data.dto.allMarketingProgramDto && data.dto.allMarketingProgramDto.carProgramList) || ''
        if (carProgramList) {
          carProgramList = carProgramList.find(c => {
            return c.insSupplierId === 888
          }) || ''
        }
        this.$store.dispatch('setCommon', { key: 'carProgramData', value: carProgramList })
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import url(../assets/less/color.less);
.header-box {
  height: 60px;
  min-height: 60px;
  max-height: 60px;
  line-height: 60px;
  border-bottom: 1px solid #e6e6e6;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .iconfont {
    font-size: 16px;
    padding: 0 8px;
    cursor: pointer;
    vertical-align: middle;
    &.setting {
      font-size: 18px;
    }
    &.active {
      color: @color;
    }
  }
  .cloud__image {
    // width: 26px;
    vertical-align: text-top;
    margin-right: 5px;
    max-width: 20px;
    &.default__image {
      width: 26px;
    }
  }
  .userinfo {
    text-align: right;
    padding-right: 15px;
    float: right;
    white-space: nowrap;
    overflow: hidden;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .userinfo-inner {
      cursor: pointer;
      img {
        width: 40px;
        height: 40px;
        border-radius: 20px;
        margin: 10px 0px 10px 10px;
        float: right;
      }
    }
    .el-badge {
      &__item {
        line-height: 20px;
      }
    }
    .el-badge__content.is-fixed {
      right: 20px;
    }
    .quote {
      margin-right: 20px;
    }
    i {
      color: #8cc5ff;
      &:hover {
        color: #409eff;
      }
    }
  }
  .logo {
    height: 60px;
    font-size: 22px-2px;
    display: flex;
    position: relative;
    /* &__image {
      width: 60px;
      height: 100%;
      margin-top: -1px;
    } */
    &.logo__special {
      position: initial;
    }
  }
  &__title {
    padding: 0 26px;
    outline: none;
    font-size: 16px;
    cursor: pointer;
    display: flex;
    align-items: center;
    min-width: 150px;
  }
  &__v2 {
    position: absolute;
    right: 5%; //30%;
    background: url("../../static/images/header@2x.png") no-repeat;
    background-size: contain;
    line-height: 16px;
    font-size: 14px;
    color: @color;
    padding: 16px;
    cursor: pointer;
  }
  .logo__special {
    .header-box__v2 {
      right: 320px;
    }
  }
  .el-menu {
    background-color: transparent;
    border-bottom: none;
    overflow: hidden;
  }
  &__user {
    min-width: 160px+60px;
    text-align: left;
    line-height: 22px;
    font-size: 14px;
    &__box {
      padding: 0 20px;
    }
    &__name {
      font-size: 20px;
      max-width: 200px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    &__subdomain {
      color: #4a4a4a;
    }
    &__role {
      color: #0099ff;
    }
    &__version {
      // color: #9b9b9b;
      img{
        width: 80px;
      }
    }
    &__action {
      // padding: 0 10px;
      text-align: center;
      margin-top: 28px;
    }
    // .el-divider--horizontal {
    //   margin: 10px 0;
    // }
  }
  .dialog-box {
    &__title {
      font-size: 25px;
    }
    &__content {
      line-height: normal;
      img {
        max-width: 100%;
      }
    }
  }
  .el-dialog__body {
    line-height: 25px;
    max-height: 450px;
    overflow: auto;
  }
  &__menu {
    display: flex;
    justify-content: space-around;
    // border-bottom: 2px solid @border-color;
    margin-left: 20px;
    .header__item {
      // width: 30%;
      text-align: center;
      padding: 0 20px;
      font-size: 18px-2px;
      // color: #909399;
      cursor: pointer;
      white-space: nowrap;
      &.active {
        position: relative;
        color: @color;
        cursor: default;
        &::after {
          content: "";
          position: absolute;
          width: 100%;
          height: 2px;
          left: 0;
          background-color: @color;
          bottom: 0px;
        }
      }
      &__box {
        display: flex;
        position: relative;
        padding-left: 20px;
        &:hover {
          cursor: pointer;
          background-color: @border-color;
        }
        .item__block {
          font-size: 12px;
          position: absolute;
          left: 0;
          color: #909399;
        }
      }
    }
    .hidden_pointer {
      position: absolute;
      height: 60px;
      z-index: 10;
    }
  }
  .home-dialog {
    img {
      width: 100%;
    }
    .d_desc {
      padding: 8px 16px;
      background-color: #ecf8ff;
      border-radius: 4px;
      border-left: 5px solid #50bfff;
      margin: 20px 0;
    }
    .d-tip {
      color: red;
    }
    .d-title {
      font-size: 16px;
      font-weight: 600;
    }
    ul {
      padding-left: 0px;
      li {
        list-style: none;
        line-height: 22px;
        i {
          color: #43b0ff;
          margin: auto 4px;
        }
      }
    }
  }
  .hongbao {
    img {
      vertical-align: text-bottom;
    }
    .el-badge{
      line-height: 24px;
    }
    &:hover {
      cursor: pointer;
      opacity: 0.9;
    }
  }
}
.el-dropdown-menu {
  max-height: 486px;
  border: none;
}
.el-badge__content {
  top: 18px !important;
}
.el-dropdown-menu__header {
  top: 35px !important;
  .tab-box {
    min-width: 260px;
  }
  .el-tabs {
    position: relative;
    top: -6px;
  }
  .message-box {
    padding: 0 10px;
    min-width: 150px;
    &__item {
      padding: 10px 0;
      cursor: pointer;
      & + .message-box__item {
        border-top: 1px solid @border-color;
      }
      .badge__kf {
        sup {
          margin-top: -22px;
        }
      }
      .item_txt {
        font-weight: 600;
        margin-top: -4px;
        font-size: 16px;
        &:hover {
          opacity: 0.8;
        }
      }
      .iconfont {
        font-size: 20px;
        margin-right: 5px;
      }

      .qrcode-box {
        width: 150px;
        img {
          width: 100%;
        }
        &__img {
          width: 135px !important;
        }
      }
      .icon-kf__text {
        color: @color;
        // text-decoration: underline;
      }
      .img-small {
        width: 21px;
        height: 21px;
        vertical-align: bottom;
        margin-right: 5px;
      }
      .video-box {
        width: 180px;
        font-size: 12px;
        margin-left: 2px;
        margin-top: 22px;
        line-height: 19px;
        span{
          color:red;
        }
        ul{
          list-style-type: none;
          padding: 0;
          margin: 10px 0;
        }
      }
    }

    .flex {
      display: flex;
    }
    .flex-b {
      justify-content: space-between;
    }
    .flex-d {
      flex-direction: column;
      font-size: 12px;
    }
    .box__item + .box__item {
      height: 179px;
      .qrcode-box {
        padding-top: 8px;
      }
    }
    .icon-erweima {
      vertical-align: bottom;
    }
    .message-box__item__text {
      font-size: 16px;
    }
  }
  &.header__main {
    .el-dropdown-menu__item {
      font-size: 18px;
      line-height: 35px;
      padding: 0 30px 0 10px;
      &.el-dropdown-menu__item--divided:before {
        margin: 0 -30px;
      }
    }
    .active {
      // background-color: #ecf5ff;
      color: #66b1ff;
    }
    .item__image {
      width: 20px;
    }
  }
}
.carouse-item__content {
  height: 100%;
  overflow: auto;
  img {
    max-width: 100%;
  }
}
.guidelayer {
  position: fixed;
  left: 0;
  top: 0;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  z-index: 999;
  img {
    width: 98%;
  }
  .title {
    padding: 0 20px;
    font-size: 16px;
    background: #409eff;
    color: #fff;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    .strong {
      height: 30px;
      font-size: 20px;
      font-weight: bold;
    }
    .dictionary {
      color: #eaf6ff;
      height: 50px;
    }
  }
  .line {
    margin: 0 20px;
    border: 0.5px dashed #ccc;
  }
  .step {
    height: 30px;
    line-height: 30px;
    padding-left: 20px;
    font-weight: bolder;
    font-size: 12px;
  }
  .wrap {
    position: relative;
    width: 46%;
    margin-top: 2%;
    left: 50%;
    margin-left: -23%;
    border-radius: 5px;
    background: #fff;
    text-align: left;
    i {
      float: right;
      margin-top: -20px;
      margin-right: -30px;
      color: #aaa;
      font-size: 26px;
      cursor: pointer;
      &:hover {
        color: #fff;
      }
    }
  }
  .btn {
    margin-top: 18px;
    font-size: 16px;
    padding: 12px 23px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue